import { render, staticRenderFns } from "./Souhuo.vue?vue&type=template&id=602af13f&scoped=true&"
import script from "./Souhuo.vue?vue&type=script&lang=js&"
export * from "./Souhuo.vue?vue&type=script&lang=js&"
import style0 from "./Souhuo.vue?vue&type=style&index=0&id=602af13f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602af13f",
  null
  
)

export default component.exports